export function extractKeyValuePairs(
  search: string
): { key: string; value: string[]; start: number; end: number }[] {
  const results: {
    key: string;
    value: string[];
    start: number;
    end: number;
  }[] = [];

  // Updated regex to handle both comma and pipe separators between quoted and unquoted values
  const regex = /([^:\s]+):((?:"[^"]*"|[^,|\s"]+)(?:\s*[,|]\s*(?:"[^"]*"|[^,|\s"]+))*)/g;

  let match;
  while ((match = regex.exec(search)) !== null) {
    const key = match[1];
    const valueString = match[2];
    const start = match.index;
    const end = start + match[0].length;

    // Handle comma/pipe-separated values or single values
    const valueRegex = /"[^"]*"|[^,|\s"]+/g;
    const values: string[] = [];
    let valueMatch;
    while ((valueMatch = valueRegex.exec(valueString)) !== null) {
      const value = valueMatch[0];
      // Remove quotes if present
      values.push(value.replace(/^"(.*)"$/, "$1").trim());
    }
    results.push({ key, value: values, start, end });
  }

  return results;
}
